<template>
    <div>
        <a href="#" @click.prevent="isShowForm = true" class="newsletter" v-if="!isShowForm">
            <i class="far fa-envelope"></i>
            {{ text }}
        </a>

        <div v-if="error !== ''">
            {{ error }}
        </div>
        <div class="form-inline" v-if="isShowForm && success === ''">
            <div class="form-group mr-2">
                <input type="text" class="form-control" v-model="form.name" aria-label="Név" placeholder="Név..." required>
                <span v-if="errors.name" role="alert">{{ errors.name[0] }}</span>
            </div>
            <div class="form-group mr-2">
                <input type="email" id="email" class="form-control" v-model="form.email" aria-label="E-mail cím" placeholder="E-mail cím..." required>
                <span v-if="errors.email" role="alert">{{ errors.email[0] }}</span>
            </div>
            <button type="button" class="btn btn-primary" @click="subscribe"><span class="fa fa-spin fa-spinner" v-if="isLoading"></span> {{ button }}</button>
        </div>
        <div v-if="success !== ''" role="alert">
            {{ success }}
        </div>
    </div>
</template>
<script>
    export default {
        name: 'NewsletterSubscribe',
        props: {
            text: {
                type: String,
                required: true
            },
            button: {
                type: String,
                required: true
            },
            url: {
                type: String,
                required: true
            },
        },
        data() {
            return {
                form: {
                    name: '',
                    email: ''
                },
                isShowForm: false,
                success: '',
                errors: {},
                error: '',
                isLoading: false
            }
        },
        methods: {
            subscribe() {
                this.isLoading = true;
                this.error = '';
                this.errors = {};
                axios.post(this.url, this.form).then(response => {
                    this.success = response.data.message;
                    this.isLoading = false;
                }).catch(error => {
                    if (error.response.status === 422 && typeof error.response.data.errors !== 'undefined') {
                        this.errors = error.response.data.errors;
                    } else if (typeof error.response.data.message !== 'undefined') {
                        this.error = error.response.data.message;
                    }
                    this.isLoading = false;
                });
            }
        }
    }
</script>
